import { Endpoint } from '../endpoint';
import { SenderResponse, SenderID } from '@business/entities/sender';
import { ChannelId } from '@business/entities/SupportChannel';

export function fetchSenders(channelId: ChannelId) {
  return Endpoint.get<SenderResponse[]>(`@gc/channel-senders/${channelId}`);
}

export function createSender(channelId: ChannelId, senderId: SenderID, fromEmail: string, fromName: string) {
  return Endpoint.post<SenderResponse>(`@gc/channel-senders`, { data: { channelId, senderId, fromEmail, fromName } });
}

export function makeDefault(channelId: ChannelId, id: SenderID) {
  return Endpoint.patch<SenderResponse[]>(`@gc/channel-senders/default/${channelId}/${id}`);
}

export function deleteSender(channelId: ChannelId, senderId: SenderID) {
  return Endpoint.delete<void>(`@gc/channel-senders/${channelId}/${senderId}`);
}
